export const routes = [
  {
    path: '/affiliate',
    name: '/affiliate',
    component: () => import('/app/frontend/src/pages/affiliate.vue'),
    /* no children */
  },
  {
    path: '/campaigns',
    /* internal name: '/campaigns' */
    /* no component */
    children: [
      {
        path: '',
        name: '/campaigns/',
        component: () => import('/app/frontend/src/pages/campaigns/index.vue'),
        /* no children */
      },
      {
        path: ':campaign',
        name: '/campaigns/[campaign]',
        component: () => import('/app/frontend/src/pages/campaigns/[campaign].vue'),
        children: [
          {
            path: '',
            name: '/campaigns/[campaign]/',
            component: () => import('/app/frontend/src/pages/campaigns/[campaign]/index.vue'),
            /* no children */
          },
          {
            path: 'analytics',
            name: '/campaigns/[campaign]/analytics',
            component: () => import('/app/frontend/src/pages/campaigns/[campaign]/analytics.vue'),
            /* no children */
          },
          {
            path: 'custom-domain',
            name: '/campaigns/[campaign]/custom-domain',
            component: () => import('/app/frontend/src/pages/campaigns/[campaign]/custom-domain.vue'),
            /* no children */
          },
          {
            path: 'engage',
            name: '/campaigns/[campaign]/engage',
            component: () => import('/app/frontend/src/pages/campaigns/[campaign]/engage.vue'),
            /* no children */
          },
          {
            path: 'export',
            /* internal name: '/campaigns/[campaign]/export' */
            /* no component */
            children: [
              {
                path: '',
                name: '/campaigns/[campaign]/export/',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/export/index.vue'),
                /* no children */
              },
              {
                path: 'bulk-download',
                name: '/campaigns/[campaign]/export/bulk-download',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/export/bulk-download.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'generate-videos',
            name: '/campaigns/[campaign]/generate-videos',
            component: () => import('/app/frontend/src/pages/campaigns/[campaign]/generate-videos.vue'),
            /* no children */
          },
          {
            path: 'import',
            name: '/campaigns/[campaign]/import',
            component: () => import('/app/frontend/src/pages/campaigns/[campaign]/import.vue'),
            children: [
              {
                path: '',
                name: '/campaigns/[campaign]/import/',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/import/index.vue'),
                /* no children */
              },
              {
                path: 'api',
                name: '/campaigns/[campaign]/import/api',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/import/api.vue'),
                /* no children */
              },
              {
                path: 'clay',
                name: '/campaigns/[campaign]/import/clay',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/import/clay.vue'),
                /* no children */
              },
              {
                path: 'csv',
                name: '/campaigns/[campaign]/import/csv',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/import/csv.vue'),
                /* no children */
              },
              {
                path: 'rb2b',
                name: '/campaigns/[campaign]/import/rb2b',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/import/rb2b.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'landing-page',
            name: '/campaigns/[campaign]/landing-page',
            component: () => import('/app/frontend/src/pages/campaigns/[campaign]/landing-page.vue'),
            /* no children */
          },
          {
            path: 'send',
            /* internal name: '/campaigns/[campaign]/send' */
            /* no component */
            children: [
              {
                path: '',
                name: '/campaigns/[campaign]/send/',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/send/index.vue'),
                /* no children */
              },
              {
                path: 'instantly',
                name: '/campaigns/[campaign]/send/instantly',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/send/instantly.vue'),
                /* no children */
              },
              {
                path: 'smartlead',
                name: '/campaigns/[campaign]/send/smartlead',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/send/smartlead.vue'),
                /* no children */
              },
              {
                path: 'webhooks',
                name: '/campaigns/[campaign]/send/webhooks',
                component: () => import('/app/frontend/src/pages/campaigns/[campaign]/send/webhooks.vue'),
                /* no children */
              }
            ],
          },
          {
            path: 'test-video',
            name: '/campaigns/[campaign]/test-video',
            component: () => import('/app/frontend/src/pages/campaigns/[campaign]/test-video.vue'),
            /* no children */
          },
          {
            path: 'videos',
            name: '/campaigns/[campaign]/videos',
            component: () => import('/app/frontend/src/pages/campaigns/[campaign]/videos.vue'),
            /* no children */
          }
        ],
      },
      {
        path: 'new',
        name: '/campaigns/new',
        component: () => import('/app/frontend/src/pages/campaigns/new.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/creator',
    /* internal name: '/creator' */
    /* no component */
    children: [
      {
        path: 'campaign',
        /* internal name: '/creator/campaign' */
        /* no component */
        children: [
          {
            path: ':campaign',
            name: '/creator/campaign/[campaign]',
            component: () => import('/app/frontend/src/pages/creator/campaign/[campaign].vue'),
            children: [
              {
                path: '',
                name: '/creator/campaign/[campaign]/',
                component: () => import('/app/frontend/src/pages/creator/campaign/[campaign]/index.vue'),
                /* no children */
              },
              {
                path: 'explanation',
                name: '/creator/campaign/[campaign]/explanation',
                component: () => import('/app/frontend/src/pages/creator/campaign/[campaign]/explanation.vue'),
                /* no children */
              },
              {
                path: 'record',
                name: '/creator/campaign/[campaign]/record',
                component: () => import('/app/frontend/src/pages/creator/campaign/[campaign]/record.vue'),
                /* no children */
              },
              {
                path: 'script',
                name: '/creator/campaign/[campaign]/script',
                component: () => import('/app/frontend/src/pages/creator/campaign/[campaign]/script.vue'),
                /* no children */
              },
              {
                path: 'templates',
                name: '/creator/campaign/[campaign]/templates',
                component: () => import('/app/frontend/src/pages/creator/campaign/[campaign]/templates.vue'),
                /* no children */
              }
            ],
          }
        ],
      }
    ],
  },
  {
    path: '/editor',
    /* internal name: '/editor' */
    /* no component */
    children: [
      {
        path: 'campaign',
        /* internal name: '/editor/campaign' */
        /* no component */
        children: [
          {
            path: ':campaign',
            name: '/editor/campaign/[campaign]',
            component: () => import('/app/frontend/src/pages/editor/campaign/[campaign].vue'),
            /* no children */
          }
        ],
      }
    ],
  },
  {
    path: '/onboarding',
    /* internal name: '/onboarding' */
    /* no component */
    children: [
      {
        path: 'agency-offer',
        name: '/onboarding/agency-offer',
        component: () => import('/app/frontend/src/pages/onboarding/agency-offer.vue'),
        /* no children */
      },
      {
        path: 'get-started',
        name: '/onboarding/get-started',
        component: () => import('/app/frontend/src/pages/onboarding/get-started.vue'),
        /* no children */
      },
      {
        path: 'job-title',
        name: '/onboarding/job-title',
        component: () => import('/app/frontend/src/pages/onboarding/job-title.vue'),
        /* no children */
      },
      {
        path: 'persona',
        name: '/onboarding/persona',
        component: () => import('/app/frontend/src/pages/onboarding/persona.vue'),
        /* no children */
      },
      {
        path: 'referral-source',
        name: '/onboarding/referral-source',
        component: () => import('/app/frontend/src/pages/onboarding/referral-source.vue'),
        /* no children */
      },
      {
        path: 'register',
        name: '/onboarding/register',
        component: () => import('/app/frontend/src/pages/onboarding/register.vue'),
        /* no children */
      },
      {
        path: 'trial',
        name: '/onboarding/trial',
        component: () => import('/app/frontend/src/pages/onboarding/trial.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/org',
    /* internal name: '/org' */
    /* no component */
    children: [
      {
        path: '',
        name: '/org/',
        component: () => import('/app/frontend/src/pages/org/index.vue'),
        /* no children */
      },
      {
        path: 'domains',
        name: '/org/domains',
        component: () => import('/app/frontend/src/pages/org/domains.vue'),
        /* no children */
      },
      {
        path: 'thank-you',
        name: '/org/thank-you',
        component: () => import('/app/frontend/src/pages/org/thank-you.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/privacy',
    name: '/privacy',
    component: () => import('/app/frontend/src/pages/privacy.vue'),
    /* no children */
  },
  {
    path: '/profile',
    name: '/profile',
    component: () => import('/app/frontend/src/pages/profile.vue'),
    /* no children */
  },
  {
    path: '/sign-up',
    name: '/sign-up',
    component: () => import('/app/frontend/src/pages/sign-up.vue'),
    /* no children */
  },
  {
    path: '/terms',
    name: '/terms',
    component: () => import('/app/frontend/src/pages/terms.vue'),
    /* no children */
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

